import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  BlockFetch,
  DistrictFetch,
  StateFetch,
} from "../../../api/LocationService";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { GetSingleData, UpMarketingSchool } from "../../../api/MarketinService";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { getSessions } from "../../../api/SessionsService";
import { ToastMain, SweetAlertShow } from "../../master/Master";
import { FaSearch } from "react-icons/fa";
import MarketingHeader from "./MarketingHeader";
const UpdateMarketingSchool = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [school, setSchool] = useState([]);
  const [HostelId, setHostelId] = useState("");
  const [allStates, setAllStates] = useState([]);
  const [allDistricts, setAllDistricts] = useState([]);
  const [allBlock, setAllBlock] = useState([]);
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [subjects, setSubjects] = useState("");
  const [session, setSession] = useState("");
  const [data, setData] = useState("");
  const [SelectedSession, setSelectedSession] = useState("");
  const location = useLocation();

  const queryparam = new URLSearchParams(location.search);
  const school_data = queryparam.get("id");

  // const school_data = location?.state.id
  // const school_data = location.state?.school;

  const updateSchool = async (e) => {
    setLoading(true);
    e.preventDefault();

    try {
      const formData = new FormData(e.target);
      formData.append("session_id", SelectedSession);

      await UpMarketingSchool(formData);

      ToastMain.fire({
        icon: "success",
        title: "updated successfully!",
      });
      navigate("/marketing");
    } catch (error) {
      // ToastMain.fire({
      //     icon: 'error',
      //     title: error?.response?.data?.message || 'something went wrong!'

      // })
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getState = async () => {
    setLoading(true);
    try {
      const response = await StateFetch();
      if (response.data) {
        // console.log("Fetched:", response.data.data.states);
        setAllStates(response?.data?.states);
      }
    } catch (error) {
      // ToastMain.fire({
      //     icon: 'error',
      //     title: error?.response?.data?.message || 'something went wrong!'

      // })

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getSingleData = async () => {
    let addUrl = `id=${school_data}`;
    setLoading(true);
    try {
      const response = await GetSingleData(addUrl);
      if (response.data.status) {
        setData(response.data);

        // ✅ THIS IS MISSING
        setSelectedSession(response?.data?.data?.session_id);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (school_data) {
      getSingleData();
    }
  }, []);

  const getdistrict = async (state = "") => {
    setLoading(true);
    try {
      const response = await DistrictFetch(state);
      if (response.data) {
        setAllDistricts(response?.data?.districts);
      }
    } catch (error) {
      // ToastMain.fire({
      //     icon: 'error',
      //     title: error?.response?.data?.message || 'something went wrong!'

      // })

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const getblock = async (district = "") => {
    setLoading(true);
    try {
      const response = await BlockFetch(district);
      if (response?.data) {
        setAllBlock(response?.data?.blocks);
      }
    } catch (error) {
      // ToastMain.fire({
      //     icon: 'error',
      //     title: error?.response?.data?.message || 'something went wrong!'

      // })

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    } finally {
      setLoading(false);
    }
  };


  const getSession = async () => {
    try {
      const response = await getSessions();
      if (response.data.status) {
        console.log("session fetched", response.data);
        setSession(response?.data);
      } else {
        setError("Failed to fetch session.");
      }
    } catch (error) {
      // ToastMain.fire({
      //     icon: 'error',
      //     title: error?.response?.data?.message || 'something went wrong!'

      // })

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    }
  };

  useEffect(() => {

    getState();
    getSession();
    getdistrict();
    getblock();
  }, []);
  const navigate = useNavigate();
  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />

            <div className="container-fluid mt-2">
              <div className="d-flex gap-2">
                <MarketingHeader data={"Marketing Portal"} />

                <div className="card">
                  <div className="card-body">
                    <div className="mt-4">
                      <div className="d-flex justify-content-between">
                        {/* {JSON} */}
                        <h4 className="text-primary">Source Update</h4>
                        <Link
                          to={`/marketing`}
                          className="btn btn-outline-primary mb-3 mt-3"
                        >
                          <i className="bi bi-arrow-left-circle me-1"></i>
                          Back
                        </Link>
                      </div>
                      <form onSubmit={updateSchool}>
                        <input
                          type="hidden"
                          name="id"
                          defaultValue={school_data}
                        />
                        <div className="row mb-3">
                          <div className="col-md-12 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <select
                              className="form-select"
                              name="session_id"
                              value={SelectedSession || ""}
                              onChange={(e) =>
                                setSelectedSession(e.target.value)
                              }
                            >
                              <option value="">Select Session</option>

                              {session?.data?.map((sess) => (
                                <option key={sess.id} value={sess.id}>
                                  {sess.session} :{" "}
                                  {sess.status === "1" ? "Active" : "Inactive"}
                                </option>
                              ))}
                            </select>

                            <label className="ms-5">Session</label>
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col-md-6 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <textarea
                              className="form-control text-capitalize input-uppercase"
                              name="source_name"
                              placeholder="Name "
                              defaultValue={data?.data?.source_name}
                              rows={2}
                            ></textarea>
                            <label className="ms-5">Source Name</label>
                          </div>
                          <div className="col-md-6 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <textarea
                              className="form-control text-capitalize input-uppercase"
                              name="source_type"
                              placeholder="Name "
                              defaultValue={data?.data?.source_type}
                              rows={2}
                            ></textarea>
                            <label className="ms-5">Source Type</label>
                          </div>
                          <div className="col-md-6 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <textarea
                              className="form-control text-capitalize"
                              name="contact_no"
                              defaultValue={data?.data?.contact_no}
                              rows={2}
                            ></textarea>
                            <label className=" ms-5">Contect No</label>
                          </div>
                          <div className="col-md-6 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <textarea
                              className="form-control text-capitalize"
                              name="contact_person"
                              defaultValue={data?.data?.contact_person}
                              rows={2}
                            ></textarea>
                            <label className=" ms-5">Contect Person</label>
                          </div>

                          <div className="col-md-12 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <textarea
                              className="form-control text-capitalize input-lowercase"
                              name="email"
                              defaultValue={data?.data?.email}
                              rows={2}
                            ></textarea>
                            <label className=" ms-5">Email</label>
                          </div>
                        </div>

                        <div className="row mb-3"></div>

                        <div className="row mb-3">
                          <div className="col-md-6 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <select
                              className="form-select"
                              name="state"
                              onChange={(e) => getdistrict(e.target.value)}
                            >
                              <option value="">Select State</option>
                              {allStates?.map((state) => (
                                <option
                                  key={state.id}
                                  value={state.name}
                                  selected={
                                    data?.data?.state == state?.name && true
                                  }
                                >
                                  {state.name}
                                </option>
                              ))}
                            </select>
                            <label className="ms-5">State</label>
                          </div>
                          <div className="col-md-6 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <select
                              className="form-select text-capitalize"
                              name="district"
                              onChange={(e) => getblock(e.target.value)}
                            >
                              <option value="" name="district">
                                Select District
                              </option>
                              {allDistricts?.map((district) => (
                                <option
                                  key={district.id}
                                  value={district.name}
                                  selected={
                                    data?.data?.district == district?.name &&
                                    true
                                  }
                                >
                                  {district.name}
                                </option>
                              ))}
                            </select>
                            <label className="ms-5">District</label>
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col-md-6 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <select
                              className="form-select text-capitalize"
                              name="block"
                              placeholder="Block"
                            >
                              {allBlock?.map((blk) => (
                                <option
                                  selected={
                                    data?.data?.blocks == blk?.name && true
                                  }
                                >
                                  {blk.name}
                                </option>
                              ))}
                            </select>
                            <label className="ms-5">Block</label>
                          </div>
                          <div className="col-md-6 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <textarea
                              className="form-control text-capitalize input-uppercase"
                              name="address"
                              placeholder="Address"
                              rows={2}
                            >
                              {data?.data?.address}
                            </textarea>
                            <label className="ms-5">Address</label>
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col-md-12 mb-5 form-floating form-floating-outline mb-2 fv-plugins-icon-container">
                            <textarea
                              className="form-control text-capitalize input-uppercase"
                              name="description"
                              rows={3}
                            >
                              {data?.data?.description}
                            </textarea>
                            <label className="ms-5">Note</label>
                          </div>
                        </div>
                        <button
                          type="submit"
                          className="btn btn-primary px-5"
                          disabled={loading} // Disable the button while loading
                        >
                          {loading ? (
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            "Submit"
                          )}
                          {loading ? " Submitting..." : ""}
                        </button>
                      </form>

                      <Footer />
                      <div className="content-backdrop fade"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="layout-overlay layout-menu-toggle"></div>
          <div className="drag-target"></div>
        </div>
      </div>
    </>
  );
};

export default UpdateMarketingSchool;
